module.exports = __webpack_public_path__ + "401f042388942ab1f367f6640c188dd3.png";